/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExistingPasswordCredential interface.
 */
export function instanceOfExistingPasswordCredential(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function ExistingPasswordCredentialFromJSON(json) {
    return ExistingPasswordCredentialFromJSONTyped(json, false);
}
export function ExistingPasswordCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function ExistingPasswordCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
